import * as React from 'react';
import * as styles from './styles.css';
import { trackBlockShow } from './tracking';

const item1 = require('./assets/item1.svg') as string;
const item2 = require('./assets/item2.svg') as string;
const item3 = require('./assets/item3.svg') as string;

export const NewDealRentOfferInfoBlock = () => {
  React.useEffect(trackBlockShow, []);

  return (
    <div className={styles['container']}>
      <h1 className={styles['title']}>Эта квартира – особенная</h1>
      <div className={styles['description']}>
        Она сдаётся собственником с помощью сервиса Сдай/Сними. Заплатите единоразовую комиссию в&nbsp;15% от стоимости
        аренды Циан, и мы:
      </div>
      <div className={styles['adv']}>
        <img src={item1} className={styles['adv-icon']} />
        <div className={styles['adv-content']}>
          <div className={styles['adv-title']}>Оплатим переезд</div>
          <div className={styles['adv-description']}>
            Дарим 3 000 ₽ на переезд любой транспортной компанией. Переезжайте без лишнего стресса!
          </div>
        </div>
      </div>
      <div className={styles['adv']}>
        <img src={item2} className={styles['adv-icon']} />
        <div className={styles['adv-content']}>
          <div className={styles['adv-title']}>Сдадим новую квартиру без комиссии</div>
          <div className={styles['adv-description']}>
            Пришлось съехать по вине собственника? Сдадим новую квартиру Сдай/Сними без комиссии{' '}
          </div>
        </div>
      </div>
      <div className={styles['adv']}>
        <img src={item3} className={styles['adv-icon']} />
        <div className={styles['adv-content']}>
          <div className={styles['adv-title']}>Решим конфликты и ответим на вопросы</div>
          <div className={styles['adv-description']}>
            Если понадобится помощь в решении проблемы или консультация – мы на связи{' '}
          </div>
        </div>
      </div>
    </div>
  );
};
